import React from 'react';
import classNames from 'classnames';
import { Field } from 'redux-form';
import { isArray, isUndefined } from 'lodash';
import { connect } from 'react-redux';
import Help from '../Help';
import { maxLength, isLogged, isPublic, isNotLogged } from '../../CroUtils';

const isRequired = ({ validate }) => {
  return isArray(validate) ? validate.some(fun => fun.croName === 'required') : false;
}

const required = (auth, fieldRest) =>
  (isNotLogged(auth) && !fieldRest.disabled) || (isLogged(auth) && isPublic(auth) && !fieldRest.disabled) || (isLogged(auth) && !isPublic(auth));

const CroCheckbox = ({ className, title, labelStyle, helpEnum, maxlen, auth, ...fieldRest }) => (
  <div className={classNames(className, "checkbox")}>
    <label className={classNames("title", { required: isRequired(fieldRest) && required(auth, fieldRest) })} style={labelStyle}>{title}</label>
    <Field helpEnum={helpEnum} {...fieldRest} fullWidth normalize={fieldRest.normalize ? fieldRest.normalize : maxlen ? maxLength(maxlen) : maxLength(255)} />
    {!isUndefined(helpEnum) &&
      <span className='help-icon'>
        <Help helpEnum={helpEnum} disabled={fieldRest.disabled} />
      </span>
    }
  </div>
);

const mapStateToProps = (state) => ({
  auth: state.sidebar.auth,
});

export default connect(mapStateToProps)(CroCheckbox)